import FayeMessager from './FayeMessager';
import store from 'store';
import { newTask, initialFetch } from 'reducers/TasksReducer';
import { GetUserId, GetUserToken } from 'helpers/UserHelper';

const NEW_TASK = 'sure-quote/tasks/task/NEW_TASK';

const PUSH_TO_API = '/Result/';
const GET_USER_TASKS = '/task/getUserTasks';

// var RESULT_UDATE  -- percentasge complete
// var RESULT_INFO -- final infromaton of task
class TaskManager {
	constructor() {
		const faye = new FayeMessager();
		this.messager = faye;
		global.messager = faye;

		this.handlerFactoryFuncs = new Map();
	}

	initialFetch() {
		global.messager.publish(GET_USER_TASKS, {
			uid: GetUserId()
		});

		this.messager.subscribe(`${GET_USER_TASKS}/${GetUserId()}`, data => {
			store.dispatch(initialFetch({ tasks: data }));
		});
	}

	start() {
		if (!global.glob && GetUserToken() !== '')
			this.messager.subscribe(PUSH_TO_API + GetUserId(), msg => {
				this.onNewResult(msg);
			});
	}

	stop() {}

	// Here we recieve results from the scraping server
	onNewResult(msg) {
		store.dispatch(newTask({ type: NEW_TASK, props: msg }));
		return msg;
	}
}

export default TaskManager;



// WEBPACK FOOTER //
// ./src/components/SqTasks/task/TaskManager.js